// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSpace24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.3353 1.32918L22.3353 6.32918C22.8881 6.60557 22.8881 7.39443 22.3353 7.67082L12.3353 12.6708C12.1242 12.7764 11.8757 12.7764 11.6645 12.6708L1.66451 7.67082C1.11172 7.39443 1.11172 6.60557 1.66451 6.32918L11.6645 1.32918C11.8757 1.22361 12.1242 1.22361 12.3353 1.32918ZM22.6707 11.6646L22.6191 11.5766C22.411 11.2714 22.0041 11.1594 21.6645 11.3292L11.9999 16.161L2.33533 11.3292C1.96485 11.1439 1.51434 11.2941 1.3291 11.6646C1.14386 12.0351 1.29403 12.4856 1.66451 12.6708L11.6645 17.6708C11.8757 17.7764 12.1242 17.7764 12.3353 17.6708L22.3353 12.6708C22.7058 12.4856 22.856 12.0351 22.6707 11.6646ZM22.6707 16.6646L22.6191 16.5766C22.411 16.2714 22.0041 16.1594 21.6645 16.3292L11.9999 21.161L2.33533 16.3292C1.96485 16.1439 1.51434 16.2941 1.3291 16.6646C1.14386 17.0351 1.29403 17.4856 1.66451 17.6708L11.6645 22.6708C11.8757 22.7764 12.1242 22.7764 12.3353 22.6708L22.3353 17.6708C22.7058 17.4856 22.856 17.0351 22.6707 16.6646ZM3.67592 7L11.9999 2.838L20.3229 7L11.9999 11.161L3.67592 7Z"
				/>
			</Svg>
		);
	}
);
SvgSpace24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSpace24;
